import React, { Component } from 'react';
import {Switch, Route, Redirect} from 'react-router-dom';
import RepositoryList from './repository_list';
import RepositorySelectorList from './repository_selector_list';
import RepositorySelectorAdd from './repository_selector_add';
import RepositorySelectorEdit from './repository_selector_edit'
class DataRepositorySetting extends Component {
  render() {
    return (
        <Switch>
             <Route path="/settings/data-repository/:repository_id/selectors/:selector_id/edit" component={RepositorySelectorEdit}/>

            <Route path="/settings/data-repository/:repository_id/selectors/add" component={RepositorySelectorAdd}/>

        <Route path="/settings/data-repository/:repository_id/selectors" component={RepositorySelectorList}/>
        <Route path="/settings/data-repository" component={RepositoryList}/>
        {/* <Route path="/settings/datatype/:datatype_id/services" component={DataServicesList}/>


        <Route path="/settings/datatype/:datatype_id/pipelines/create" component={DataPipelineCreate}/>
        <Route path="/settings/datatype/:datatype_id/pipelines/:pipeline_id" component={DataPipelineDetail}/>
        <Route path="/settings/datatype/:datatype_id/pipelines" component={DataPipelineList}/>
        <Redirect from="/settings/datatype/:datatype_id" to= "/settings/datatype"/>
        <Route path="/settings/datatype" component={DataTypeList}/> */}
        <Redirect from="*" to= "/settings/data-repository"/>
    </Switch>
    );
  }
}

export default DataRepositorySetting;
